import { WITHDRAWAL_FIND } from "../../routes";
import customAxios from "../../customAxios";
import { IWithdrawalFind } from "../../../types/common.interface";

async function findWithdrawal(props: IWithdrawalFind) {
  const thisUrl = WITHDRAWAL_FIND;
  const populate = "userId province city company driver";

  let body: any = {
    // pagination
    sort: props?.sort,
    page : props?.page,
    limit: props?.limit,
    // filters
    type: props?.filters?.type,
    // others
    populate,
  };


  // ?? Academic year (سال تحصیلی) scope, set last so the branches above cannot drop it.
  if (props.academicYear) body.academicYear = props.academicYear;

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ WITHDRAWAL_FIND: error });
  }
}

export default findWithdrawal;
